import React, { FC, } from 'react';
import { Box, Button, Grid, IconButton, Tooltip, Typography, } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import moment from 'moment';
import { AppState, } from '../../../../store';
import useStyles from './styles';
import FileUploader from '../../../file-loader';
import { enqueueSnackbarAction } from '../../../../store/snackbar/actions';
import TimeRange from '../../../time-range';
import { Command } from '../../../../entities/commands-v1/command';
import { QueryParameterKeys } from '../../../../globals/paramter';
import { uploadCommandsInfoCSV } from '../../../../store/bulk-device-flash/actions';
import { csvExportCommand, downloadTemplateForBulkCommandFetch } from '../../csv-template';
import DownloadIcon from '../../../../assets/icons/download-icon';
import theme from '../../../../globals/theme';

function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

const PendingCommandReport: FC = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const commands: Command[] = useSelector((state: AppState) => state.commands.commands);
    const location = useLocation();
    const parameters: URLSearchParams = new URLSearchParams(location.search);
    const startTime = parameters.get(QueryParameterKeys.startTime) || undefined;
    const endTime = parameters.get(QueryParameterKeys.endTime) || undefined;

    const exportCsv = async () => {
        const expectKeys = ["deviceKey", "deviceId", "deviceType", "commandId", "statusMessage", "fileType", "modifiedBy", "modifiedDateTime", "applicationId"];
        const csvData: Array<string> = [];
        commands.forEach((item: any) => {
            const errorRow: Array<any> = [];
            expectKeys.forEach((key: any) => {
                errorRow.push(item[key]);
            });
            csvData.push(`${errorRow.join(',')}`);
        });
        const csvHeader = csvExportCommand.split(',');
        const blob = new Blob(
            [`${csvHeader.join(',')}\n${csvData.join('\n')}`],
            {
                type: 'text/plain;charset=utf-8',
            },
        );
        await saveAs(blob, `export_command_${moment().format('MMMM_Do_YYYY_h:mm:ss_a')}.csv`);
        await delay(500);
        dispatch(
            enqueueSnackbarAction({
                message: 'Exported Successfully',
                options: { key: (Date.now() + Math.random()).toString(), variant: 'success' },
            }),
        );
    }

    return (
        <>
            <Grid container direction="row">
                <Box pt='10px'>
                    <Button
                        className={clsx(classes.button, classes.buttonMargin)}
                        variant="outlined"
                        size="small"
                        onClick={() => downloadTemplateForBulkCommandFetch()}
                    >
                        Download Template
                    </Button>
                </Box>
                <Box px={3} paddingTop='15px'>
                    <TimeRange blockFutureDates />
                </Box>
                <Box px={3} paddingTop='10px'>
                    <FileUploader text="Upload CSV" handleFile={(file: any) => dispatch(uploadCommandsInfoCSV(file, startTime, endTime))} />
                </Box>
                <Box pl={3} pt={2}><Typography variant='h6'>Export Commands</Typography></Box>
                <Box px={1} paddingTop='5px'>
                    <Tooltip title="Export Command" enterDelay={600}>
                        <IconButton
                            onClick={exportCsv}
                            id="exportButton"
                            size="large">
                            <DownloadIcon fill={theme.palette.grey[600]} />
                        </IconButton>

                    </Tooltip>
                </Box>
            </Grid>
        </>
    )
};

export default PendingCommandReport;

